import React, {useEffect, useState} from 'react';
import Home from '../home/Home';

/**
 * Wraps the desktop /map page (Home) and redirects mobile/tablet visitors
 * to the dedicated mobile build at /mobile/map.
 *
 * Why this exists:
 * - public/index.html has a redirect script, but it only runs on a full page
 *   load. When the user clicks a React Router <Link to="/map"> from another
 *   page in the SPA, that script never fires — so without this guard, mobile
 *   users would see the desktop Home component.
 *
 * The detection logic intentionally matches public/index.html so both layers
 * agree. If you change one, change the other.
 *
 * Override with ?desktop=1 to force the desktop version on a mobile device.
 */
const isMobileDevice = () => {
    if (typeof window === 'undefined') return false;
    if (/[?&]desktop=1/.test(window.location.search)) return false;
    const ua = navigator.userAgent || '';
    const uaMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    const touchTablet = (navigator.maxTouchPoints || 0) > 2
        && window.matchMedia('(max-width: 1024px)').matches;
    return uaMobile || touchTablet;
};

const MapRouteGuard = () => {
    // Decide synchronously on first render so we don't briefly flash the
    // desktop Home component before redirecting.
    const [shouldRedirect] = useState(() => isMobileDevice());

    useEffect(() => {
        if (shouldRedirect) {
            const target = '/mobile' + window.location.pathname
                + window.location.search + window.location.hash;
            window.location.replace(target);
        }
    }, [shouldRedirect]);

    if (shouldRedirect) {
        // Render nothing while the browser performs the redirect.
        return null;
    }

    return <Home/>;
};

export default MapRouteGuard;
